import React, { FunctionComponent } from 'react';
import {
  IStickySectionProps,
  StickySection
} from './sticky-section/sticky-section';
import styles from './sticky-sections-wrapper.module.scss';

export interface IStickySectionsWrapperProps {
  sections: IStickySectionProps[];
  image: {
    url: string;
    description: string;
  };
}

export const StickySectionsWrapper: FunctionComponent<IStickySectionsWrapperProps> = ({
  sections,
  image
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.sections}>
          {sections &&
            sections.map((section, i) => (
              <StickySection key={i} {...section} />
            ))}
        </div>
        <div className={styles.stickyWrapper}>
          <div className={styles.image}>
            <img src={image.url} alt={image.description} />
          </div>
        </div>
      </div>
    </div>
  );
};
